import React, { useState, useEffect, useGlobal } from 'reactn';
import { HistoricalItemsStyled } from './HistoricalItems.styled';
import { fakeTrackingItems } from '../deliveryItems/fakeapi';
import DeliveryItemCard from '../../_common/deliveryItemCard/DeliveryItemCard';
import { ReactComponent as Arrow } from '../../../images/rightArrow.svg';
import { getTrackingHistory } from '../../../services/Api';
import Loader from "shared-anpost-components/components/loader/Loader";
import SingleItemHistory from '../../_pages/singleItemHistory';
import profileHooks from '../../../hooks/profileHooks';
import DetectDeviceResize from "shared-anpost-components/hooks/detectDeviceResizeHook";
import { pushDataLayer } from '../../../helpers/Helpers';

const HistoricalItems = ({ history, handleHistoricalStatus }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selectedTrackingItem, setSelectedTrackingItem] = useGlobal("selectedTrackingItem");
    const [selectedTrackingItemDetails, setSelectedTrackingItemDetails] = useGlobal("selectedTrackingItemDetails");
    const { values } = profileHooks();

    const { isMobile } = DetectDeviceResize();


    useEffect(() => {
        setLoading(true);
        setSelectedTrackingItem(null)
        getTrackingHistory(values.ciamUserId).then((res) => {
            setData(res.data.trackingItems.filter(item => item.isHistorical && item.returnType === "RECEIVER"));
        })
            .finally(() => setLoading(false));
    }, [])

    const handleBack = () => {
        if (selectedTrackingItem) setSelectedTrackingItem(null)
        else handleHistoricalStatus(false)
    }

    const handleHistoricalItemSelected = (item) => {
        setLoading(true);
        getTrackingHistory(values.ciamUserId, item.trackingNumber).then((res) => {
            setSelectedTrackingItemDetails(res.data.trackingItemHistories)
        }).finally(() => setLoading(false));
        setSelectedTrackingItem(item);
        pushDataLayer({
            event: "trackingItem",
            retailer_name: item.retailerName,
        })
    }


    return (
        <HistoricalItemsStyled>
            {loading && <Loader />}
            <div className='backButton' onClick={handleBack}>
                <Arrow className="arrow" />
                <span>Back</span>
            </div>
            <div>
                <p className='pageTitle'>{selectedTrackingItem ? "Item History" : "Delivery History"}</p>
            </div>
            {selectedTrackingItem ? <SingleItemHistory /> : <>     {data && data.sort((a, b) => {
                return new Date(b.dateDelivered) - new Date(a.dateDelivered);
            }).map((item, index) => {
                return <DeliveryItemCard
                    key={index}
                    isHistorical={true}
                    history={history}
                    isExtended={!isMobile}
                    trackingItem={item}
                    handleSelected={() => handleHistoricalItemSelected(item)}
                    selected={false}
                />
            })}</>}
        </HistoricalItemsStyled>
    );
};

export default HistoricalItems;